import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footer p-4">
       <div className="col-md-12">
          <div className="d-flex justify-content-center text-center pt-4 ">
            <label style={{ color: "#666868",fontSize: '14px' }}>
              In case you are looking for additional details or would like to download an excel file of the statement, please log into <a href="https://app.mintifi.com/soa" target="_blank">https://app.mintifi.com/soa</a> to get more information. You will need to use your registered mobile number to log into the system.
              <br/>
              <br/>
               In case you are facing any issues in logging into your account, please feel free to reach out to us on <a href="mailto:customercare@mintifi.com">customercare@mintifi.com</a>
            </label>
          </div>
        </div>
        <div className="col-md-12">
          <div className="d-flex justify-content-center pt-2">
            <label style={{ color: "#666868" ,fontSize: '14px' }}>
              Disclaimer : Computer generated statement does not require
              signature
            </label>
          </div>
        </div>
        <hr />
        <div className="row footer-bottom">
          <div className="col-12 col-lg-3 col-md-6 mt-2 mb-2 d-flex align-items-center justify-content-center">
            <img
              className="pl-1 pr-1"
              width="30px"
              src="/images/StatementOfAccount/mail.svg"
              alt="download"
            />
            <a href="mailto:customercare@mintifi.com">customercare@mintifi.com</a>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mt-2 mb-2 d-flex align-items-center justify-content-center">
            <img
              className="pl-1 pr-1"
              width="30px"
              src="/images/StatementOfAccount/whatsapp.svg"
              alt="download"
            />            
            <a href="#">+91 72089 03072</a>
          </div>
          <div className="col-12 col-lg-6 mt-2 mb-2 d-flex align-items-center justify-content-center">
            <img
              className="pl-1 pr-1"
              width="30px"
              src="/images/StatementOfAccount/location.svg"
              alt="download"
            />
            Time Square Building, Andheri - Kurla Rd, Chimatpada, Marol, Andheri
            East, Mumbai, Maharashtra 400059
          </div>
        </div>
      </div>
    );
  }
}
export default Footer;
